import React, { Context, createContext } from 'react';
import {RootStore} from './store';
import {ContainerInstance} from "typedi";

export interface AppContextInterface {
    ioc: ContainerInstance | null;
    rootStore: RootStore | null;
}

export const AppContext: Context<AppContextInterface> = createContext<AppContextInterface>({
    ioc: null,
    rootStore: null
});
